import { Button, InputNumber } from 'antd';
import type { CategoryRateTier } from '@salaries/shared';

// Participant brackets → ₪ per class, shared by the series and קטגוריה rate
// editors. One 0–∞ bracket is a flat rate.

export const FLAT_TIER: CategoryRateTier = { min_participants: 0, max_participants: null, amount: 0 };

export function RateTiersEditor({
  tiers,
  onChange,
}: {
  tiers: CategoryRateTier[];
  onChange: (t: CategoryRateTier[]) => void;
}) {
  const patch = (i: number, p: Partial<CategoryRateTier>) =>
    onChange(tiers.map((t, j) => (j === i ? { ...t, ...p } : t)));
  return (
    <div className="mt-3">
      {tiers.map((t, i) => (
        <div key={i} className="flex items-center gap-2 mb-2 flex-wrap">
          <span className="text-small text-secondary-text">מ־</span>
          <InputNumber
            min={0}
            precision={0}
            value={t.min_participants}
            onChange={(v) => patch(i, { min_participants: Number(v) || 0 })}
            dir="ltr"
            style={{ width: 80 }}
          />
          <span className="text-small text-secondary-text">עד</span>
          <InputNumber
            min={0}
            precision={0}
            placeholder="ומעלה"
            value={t.max_participants ?? undefined}
            onChange={(v) => patch(i, { max_participants: v == null ? null : Number(v) })}
            dir="ltr"
            style={{ width: 90 }}
          />
          <span className="text-small text-secondary-text">משתתפים</span>
          <InputNumber
            min={0}
            prefix="₪"
            value={t.amount || undefined}
            onChange={(v) => patch(i, { amount: Number(v) || 0 })}
            dir="ltr"
            style={{ width: 120 }}
          />
          <span className="text-small text-secondary-text">לשיעור</span>
          {tiers.length > 1 && (
            <Button size="small" type="text" danger onClick={() => onChange(tiers.filter((_, j) => j !== i))}>
              הסר מדרגה
            </Button>
          )}
        </div>
      ))}
      <Button
        size="small"
        type="link"
        className="px-0"
        disabled={tiers.length >= 20}
        onClick={() => {
          const last = tiers[tiers.length - 1];
          const from = last ? (last.max_participants ?? last.min_participants) + 1 : 0;
          onChange([...tiers, { min_participants: from, max_participants: null, amount: 0 }]);
        }}
      >
        + מדרגה
      </Button>
    </div>
  );
}
